import React from 'react';
import RangeSlider from 'rsuite/lib/RangeSlider';

import { getNumericValue } from './helpers';

import * as Types from 'types';

type Props = {
  name: string;
  label: string;
  onChange: (value: [number, number]) => void;
  multiple?: boolean;
  className?: string;
  min: number;
  max: number;
  infinity?: boolean;
  prefix?: string;
  value: [number, number];
};

export const RangeGroup: React.FC<Props> = ({
  label,
  className,
  min,
  max,
  infinity,
  value,
  prefix,
  onChange,
}) => {
  const [value0, value1] = value;

  const maxValueLabel = infinity
    ? `${prefix ? prefix : ''}${value1}${value1 >= max ? '+' : ''}`
    : `${prefix ? prefix : ''}${value1}`;

  return (
    <aside className={`radio-group ${className || ''}`}>
      <h1 className='radio-group__label lh-1 mb-1'>{label}</h1>
      <div className='d-flex mb-mini'>
        <input
          className='w-100 mr-mini'
          type='text'
          value={`$${value0}`}
          style={{ minWidth: 0 }}
          onChange={(event) => {
            const numericValue = getNumericValue(event.currentTarget.value);

            if (isNaN(numericValue)) {
              return onChange([min, value1]);
            }

            const value = numericValue < min ? min : numericValue;
            onChange([value, value1]);
          }}
        />
        <input
          className='w-100 ml-mini'
          type='text'
          value={maxValueLabel}
          style={{ minWidth: 0 }}
          onKeyDown={(event) => {
            // Handle deletion of plus on backspace, eg. 500+ -> 50
            if (event.keyCode !== Types.KEYS.BACKSPACE || !infinity) {
              return;
            }

            const value = event.currentTarget.value;
            if (
              value[value.length - 1] === '+' &&
              event.currentTarget.selectionStart === value.length
            ) {
              event.currentTarget.value = value.slice(0, -1);
            }
          }}
          onChange={(event) => {
            const numericValue = getNumericValue(event.currentTarget.value);

            if (isNaN(numericValue)) {
              return onChange([value0, min]);
            }

            const value = numericValue >= max ? max : numericValue;
            onChange([value0, value]);
          }}
        />
      </div>
      <div className='pb-1' style={{ marginLeft: 6, marginRight: 6 }}>
        <RangeSlider
          min={min}
          max={max}
          step={5}
          value={value}
          defaultValue={value}
          onChange={onChange}
          tooltip={false}
        />
      </div>
    </aside>
  );
};
